module.exports = __webpack_public_path__ + "img/tgg-3.8b3f1431.webp";